import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { FileUpload, Modal, ModalControlModalProps, Text } from '@frontend/design-system';

interface Props {
  modalProps: ModalControlModalProps;
  onImageUpload: (files: File[]) => Promise<void>;
}

export const ImageUploadModal = ({ modalProps, onImageUpload }: Props) => {
  const { t } = useTranslation('team-chat');

  const handleFileUpload = async (files: File[]) => {
    await onImageUpload(files);
    modalProps.onClose();
  };

  return (
    <Modal {...modalProps} maxWidth={600}>
      <Modal.Header
        css={styles.header}
        onClose={modalProps.onClose}
        textAlign='left'
        closeBtnTrackingId='team-chat-2.0-file-upload-modal-close-button'
      >
        {t('Upload Image')}
      </Modal.Header>
      <Modal.Body>
        <FileUpload
          acceptedFileType={['jpeg', 'jpg', 'png']}
          helperText={
            <div css={styles.helperText}>
              <Text>{t('Drop image here')}</Text>
              <Text>{t('Accepted file formats: .jpeg, .jpg and .png')}</Text>
              <Text>{t('Max file size: 10MB')}</Text>
              <Text>{t('Max files allowed: 10')}</Text>
            </div>
          }
          trackingId='team-chat-2.0-image-upload-modal'
          multiple
          onFileUpload={handleFileUpload}
        />
      </Modal.Body>
    </Modal>
  );
};

const styles = {
  header: css`
    margin-bottom: ${theme.spacing(1)};
  `,

  helperText: css`
    margin: ${theme.spacing(0, 3)};
    text-align: center;
  `,
};
